/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioWaveIcon32Regular = forwardRef('MediaAudioWaveIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M14 5a1 1 0 1 0-2 0v22a1 1 0 1 0 2 0V5Z" }),
        React.createElement("path", { d: "M24 9a1 1 0 1 0-2 0v14a1 1 0 1 0 2 0V9Z" }),
        React.createElement("path", { d: "M29 13a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0v-6Z" }),
        React.createElement("path", { d: "M18 11a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M8 9a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M4 14a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4Z" })));
});
